import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Partner } from '@hivebrite/design-system/Partner';

const PartnersV2 = ({ partners = [] }) => {
  const renderPartners = useMemo(
    () =>
      partners.map((partner) => (
        <Partner
          customLinkFont="body-semibold-asphalt"
          key={partner.id}
          imageUrl={partner.logo_thumb_url}
          {...partner}
        />
      )),
    [partners],
  );

  return <Box flexDirection="column">{renderPartners}</Box>;
};

PartnersV2.propTypes = {
  partners: PropTypes.array,
};

export default PartnersV2;
